import React, { useEffect, useState } from "react";
import { Loader } from "react-overlay-loader";
import { Button, Col, Row, Upload, Modal } from "antd";
import Datatable from "../../component/table/dataTable";
import { InboxOutlined } from "@ant-design/icons";
import request from "../../lib/requester";
import xlsx from "xlsx";
import moment from "moment";
const { Dragger } = Upload;

const InsertBupot = () => {
  const [isLoading, setIsloading] = useState(false);
  const [data, setData] = useState([]);

  const uploadXslx = async (e) => {
    setIsloading(true);
    const f = e.file.originFileObj;
    const reader = new FileReader();
    let formData = new FormData();
    formData.append("fileUpload", f);

    reader.onload = async (e) => {
      var data = e.target.result;
      let readedData = xlsx.read(data, {
        type: "binary",
        cellDates: true,
        cellNF: false,
        cellText: false,
      });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      const dataExcel = xlsx.utils.sheet_to_json(ws, {
        header: 0,
        raw: true,
        defval: null,
      });
      const maping = dataExcel.map((value, index) => {
        return {
          CLAIM_NUMBER: value.ID_CLAIM,
        };
      });

      console.log("dataExcel : ", dataExcel);
      let url = "/api/traces/v1/claim/validate-claim-number";
      request.postTraces(url, maping, {
        success: function (response) {
          const res = response.data.data;

          let array1 = [];
          let array2 = [];
          res.filter(
            (o1) =>
              !dataExcel.some((o2) => {
                if (o1.CLAIM_NUMBER === o2.ID_CLAIM) {
                  if (o1.VALID === true) {
                    o2.DOC_STATUS = "1";
                    array1.push(o2);
                  } else {
                    o2.DOC_STATUS = "0";
                    array2.push(o2);
                  }
                }
              })
          );
          let concatArray = array2.concat(array1);
          let finalArray = concatArray.map((value, index) => {
            return {
              DOC_STATUS:
                value.DOC_STATUS === "1" ? "Match" : "Nomor tidak sesuai",
              ID_CLAIM: value.ID_CLAIM,
              NOMOR_DOKUMEN: value.NOMOR_DOKUMEN,
              NO_BUKTI_POTONG: value.NO_BUKTI_POTONG,
              TANGGAL_BUKTI_POTONG: value.TANGGAL_BUKTI_POTONG
                ? moment(value.TANGGAL_BUKTI_POTONG, "DD/MM/YYYY").format(
                    "DD/MM/YYYY"
                  )
                : value.TANGGAL_BUKTI_POTONG,
              NPWP_PEMOTONG: value.NPWP_PEMOTONG,
              NAMA_PEMOTONG: value.NAMA_PEMOTONG,
              IDENTITAS_PENERIMA_PENGHASILAN:
                value.IDENTITAS_PENERIMA_PENGHASILAN,
              NAMA_PENERIMA_PENGHASILAN: value.NAMA_PENERIMA_PENGHASILAN,
              PENGHASILAN_BRUTO: value.PENGHASILAN_BRUTO,
              PPH_DIPOTONG: value.PPH_DIPOTONG,
              KODE_OBJEK_PAJAK: value.KODE_OBJEK_PAJAK,
              TARIF: value.TARIF,
              PASAL: value.PASAL,
              MASA_PAJAK: value.MASA_PAJAK,
              TAHUN_PAJAK: value.TAHUN_PAJAK,
              STATUS: value.STATUS,
              REV_NO: value.REV_NO,
              POSTING: value.POSTING,
              ID_SISTEM: value.ID_SISTEM,
            };
          });
          setData(finalArray);
          setIsloading(false);
        },
        error: function (e) {
          setIsloading(false);
        },
      });
    };
    reader.readAsBinaryString(f);
    setIsloading(false);
  };

  const upload = async () => {
    setIsloading(true);
    let url = "/api/traces/v1/staging-bukpot";
    const param = {
      bukti_potong: data,
    };

    await request.postTraces(url, param, {
      success: function (response) {
        const res = response.data.data;
        if (response.data.statusCode === 200) {
          setIsloading(false);
          success();
        } else {
          setIsloading(false);
          warning();
        }
      },
      error: function (e) {
        setIsloading(false);
        warning();
      },
    });
  };

  const success = () => {
    Modal.success({
      title: "Success",
      content: "Success insert Bupot",
      onOk() {
        setData([]);
      },
    });
  };

  const warning = () => {
    Modal.warning({
      title: "Failed",
      content: "Failed insert Bupot",
      onOk() {
        setData([]);
      },
    });
  };

  const validate = () => {
    let valid = false;

    if (data.length < 1) {
      valid = true;
    }

    data.filter((value) => {
      if (value.DOC_STATUS !== "Match") {
        valid = true;
      }
    });

    return valid;
  };

  const handleDownloadTemplate = (e) => {
    const JSON_FOR_DOWNLOAD = [
      {
        ID_CLAIM: null,
        NOMOR_DOKUMEN: null,
        NO_BUKTI_POTONG: null,
        TANGGAL_BUKTI_POTONG: null,
        NPWP_PEMOTONG: null,
        NAMA_PEMOTONG: null,
        IDENTITAS_PENERIMA_PENGHASILAN: null,
        NAMA_PENERIMA_PENGHASILAN: null,
        PENGHASILAN_BRUTO: null,
        PPH_DIPOTONG: null,
        KODE_OBJEK_PAJAK: null,
        TARIF: null,
        PASAL: null,
        MASA_PAJAK: null,
        TAHUN_PAJAK: null,
        STATUS: null,
        REV_NO: null,
        POSTING: null,
        ID_SISTEM: null,
      },
    ];
    const workBook = xlsx.utils.book_new(); // create a new blank book
    const workSheet = xlsx.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
    xlsx.writeFile(workBook, "Template Insert Bupot.xlsx"); // initiate a file download in browser
  };

  return (
    <div>
      <section className="content">
        <div>
          <div className="row ml-1">
            <div className="col-lg-12">
              <div className="card card-info">
                <div className="card-header">Insert Bupot</div>
                <div className="card-body">
                  <Row className="mb-3" justify="center">
                    <Col md={8}>
                      <Dragger
                        name="pdf"
                        multiple={true}
                        customRequest={() => false}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={(info) => {
                          const { status } = info.file;
                          uploadXslx(info);
                        }}
                        showUploadList={false}
                      >
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">
                          Drag or Drop BUPOT Template File
                          <span className="text-danger">*</span>
                        </p>
                        <p className="ant-upload-hint">
                          Supported File : PDF File Only (.xlsx,.xls)
                        </p>
                      </Dragger>
                    </Col>
                    <Col
                      md={8}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        type="primary"
                        onClick={() => handleDownloadTemplate()}
                      >
                        Download Template
                      </Button>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={24}>
                      <Datatable data={data} title="Preview" />
                    </Col>
                  </Row>
                  <Row justify="center">
                    <Col md={8} className="mt-4">
                      <Button
                        disabled={validate()}
                        onClick={() => upload()}
                        type="primary"
                        className="btn-block w-100"
                      >
                        Upload
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Loader fullPage loading={isLoading} />
    </div>
  );
};

export default InsertBupot;
